import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'crossPlatform.title',
		'defaultMessage': 'Stog Software',
	},
	subtitle: {
		'id': 'crossPlatform.subtitle',
		'defaultMessage': 'Stripe is an always-improving toolchain that gains new features every month.</br>Our world-class engineering team constantly iteratesStripe is an always-improving',
	},
	mobile:{
		'id': 'crossPlatform.mobile',
		'defaultMessage': 'Get mobile app',
	},
	desktop:{
		'id': 'crossPlatform.desktop',
		'defaultMessage': 'Desktop applications',
	}
});


// WEBPACK FOOTER //
// ./src/components/LandingCrossPlatform/messages.js